import { withRouter } from 'react-router-dom';
import LoggingInPage from './LoggingInPage';

export default withRouter(LoggingInPage);
